<ng-template #loading>
   <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-template>

<ng-template #spinner>
   <mat-spinner diameter="30" class="common-mr25em"></mat-spinner>
</ng-template>

<ng-template #noresults>
   No Matching Accounts
</ng-template>

<div class="manage-account" *ngIf="list$ | async as accounts else loading">
   <ng-container *ngIf="accounts.length else noresults">
      <div>Bookmarked Accounts</div>
      <mat-selection-list #accountSelector class="list" [multiple]="false"> <!-- (selectionChange)="toSwitch( $event )" -->
         <mat-list-option class="clickable" (selectedChange)="toSwitch($event, account)" *ngFor="let account of accounts | filterlist: 'pinned' : true | filterlist: '' : filterString | slice: 0 : accountService.max; let i = index" [value]="account.id">
            <ng-container *ngTemplateOutlet="accountButton; context: { account: account }"></ng-container>
         </mat-list-option>

         <mat-divider style="grid-column: 1;"></mat-divider>

         <div style="grid-column: 1;">Click to switch to account</div>
      
         <mat-list-option class="clickable" (selectedChange)="toSwitch($event, account)" *ngFor="let account of accounts | filterlist: 'pinned' : false | filterlist: '' : filterString | slice: startIndex : endIndex; let i = index" [value]="account.id" [ngStyle]="{ gridColumn: i === 0 ? 1 : null }">
            <ng-container *ngTemplateOutlet="accountButton; context: { account: account }"></ng-container>
         </mat-list-option>
      </mat-selection-list>

      <mat-paginator
         *ngIf="(accounts | filterlist: 'pinned' : false).length > 10"
         [length]="(accounts | filterlist: 'pinned' : false).length"
         [pageSize]="pageSize"
         [pageSizeOptions]="[5, 10, 25, 100]"
         (page)="page = $event.pageIndex; pageSize = $event.pageSize">
      </mat-paginator>
   </ng-container>
</div>

<ng-template #accountButton let-account="account">
   <div class="clickable button accnt-text">
      <button mat-icon-button *ngIf="_loading !== account.id; else spinner" (click)="$event.preventDefault(); $event.stopPropagation(); bookmark( account )" class="common-mr1em">
         <mat-icon>{{(account.primary) ? 'star' : (account.pinned) ? 'bookmark' : 'bookmark_bordered'}}</mat-icon>
      </button>

      <!-- <div (click)="switch( account.id )" class="common-fg1"> -->
      <div class="common-fg1">
         <div class="title">{{account.name}}</div>
         <div *ngIf="account?.accountNumber" class="subtitle">Account #{{account.accountNumber}}</div>
         <div *ngIf="account?.stationCode" class="subtitle">{{account.stationCode}}</div>
      </div>
   </div>
</ng-template>
